export const AdditionalErrorMessages = {
  InvalidMinOdd: 'MINIMUM_ODD',
  InvalidMaxOdd: 'MAXIMUM_ODD',
  InvalidFreeBetMinOdd: 'INVALID_FREE_BET_MIN_ODD',
};

export const AdditionalNotificationByResponseCode = {
  InvalidMinOdd: 'error',
  InvalidMaxOdd: 'error',
  InvalidFreeBetMinOdd: 'error',
};

export const AdditionalResponseCode = {
  1008: 'InvalidMinOdd',
  1009: 'InvalidMaxOdd',
  1011: 'InvalidFreeBetMinOdd',
};
